import '../LandingPage.css';

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-bg" aria-hidden="true">
        <span className="hero-blob hero-blob--1"></span>
        <span className="hero-blob hero-blob--2"></span>
        <span className="hero-blob hero-blob--3"></span>
      </div>

      <div className="hero-content">
        <span className="hero-badge reveal">
          <span className="hero-badge-dot"></span>
          20+ years building software
        </span>

        <h1 className="hero-title reveal">
          Expert software development
          <span className="hero-title-accent"> solutions</span>
        </h1>

        <p className="hero-subtitle reveal reveal-delay-1">
          We design and build web applications that fit the way your business
          works and scale as it grows.
        </p>

        <div className="hero-actions reveal reveal-delay-2">
          <a href="#contact" className="btn btn--primary">
            Start a project
          </a>
          <a href="#about" className="btn btn--ghost">
            Learn more
          </a>
        </div>

        <div className="hero-proof reveal reveal-delay-3">
          <p className="hero-proof-label">Projects delivered in</p>
          <ul className="hero-proof-list">
            <li>Healthcare</li>
            <li>Finance</li>
            <li>E-commerce</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
